import Cookies from "js-cookie";

const TOKEN_COOKIE = "super_admin_token";
const USER_KEY = "super_admin_user";
const SESSION_TYPE = "SUPER_ADMIN";

const defaultCookieOpts = (days) => ({
  ...(days ? { expires: days } : {}),
  secure: window.location.protocol === "https:",
  sameSite: "Lax",
  path: "/",
});

const SuperAdminStorageService = {
  SESSION_TYPE,

  setAuth({ token, admin }, { remember = false, cookieDays = 8 } = {}) {
    if (!token) return;
    Cookies.set(TOKEN_COOKIE, token, defaultCookieOpts(remember ? cookieDays : undefined));
    const payload = { ...admin, sessionType: SESSION_TYPE };
    const str = JSON.stringify(payload);
    if (remember) {
      localStorage.setItem(USER_KEY, str);
    } else {
      sessionStorage.setItem(USER_KEY, str);
    }
  },

  getToken() {
    return Cookies.get(TOKEN_COOKIE) || null;
  },

  getAdmin() {
    const fromLocal = localStorage.getItem(USER_KEY);
    if (fromLocal) {
      try {
        return JSON.parse(fromLocal);
      } catch {
        return null;
      }
    }
    const fromSession = sessionStorage.getItem(USER_KEY);
    if (!fromSession) return null;
    try {
      return JSON.parse(fromSession);
    } catch {
      return null;
    }
  },

  isAuthenticated() {
    return !!this.getToken();
  },

  clearAuth() {
    Cookies.remove(TOKEN_COOKIE, { path: "/" });
    localStorage.removeItem(USER_KEY);
    sessionStorage.removeItem(USER_KEY);
  },
};

export default SuperAdminStorageService;
